<template>
  <div class="top-bar-container">
    <div class="top-bar">
      <!-- <MdiSvg class="sidebar-trigger" @click="handleToggleSidebar()" width="20" height="20"> {{ mdiMenu }} </MdiSvg>
       <router-link class="logo" to="/departments">
        {{ state.firm.name }}
      </router-link>
      <div class="delimiter"></div>
      <input type="text" class="search" placeholder="SEARCH"> -->

      <MdiSvg class="sidebar-trigger" v-on:click="handleToggleSidebar()" width="28" height="28"> {{ mdiMenu }} </MdiSvg>
      <div class="logo" v-on:click="$router.push('/codes')"></div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue';
import { mdiMenu } from "@mdi/js"
import useCorbinetApi from "@/hooks/useCorbinetApi";

const emit = defineEmits(['toggle-sidebar'])
function handleToggleSidebar() {
  emit("toggle-sidebar");
}

const state = reactive({
  firm: {
    name: "...",
    cid: ""
  },
  loading: true,
  error: null,
});

onMounted(async () => {
  try {
    const data = await useCorbinetApi.getCurrentFirm();
    state.firm = data || {
      name: "not found",
      cid: ""
    };
  } catch (error) {
    state.error = error;
    state.firm = {name: "failed"}
  } finally {
    state.loading = false;
  }
});

</script>

<style lang="scss" scoped>
.top-bar-container {
  display: none;
  width: 100%;
  background-color: var(--theme-color-background-a20);
  height: 84px;
  z-index: 35;
  position: relative;
}

.top-bar {
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 14px;
  z-index: 50;

  .logo {
    display: flex;
    height: 84px;
    width: 280px;
    background-image: url("@/assets/logo-v1.png");
    background-size: auto 42px;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;

    &:hover {
      cursor: pointer;
    }
  }

  .sidebar-trigger {
    position: absolute;
    left: 16px;
    top: 20px;
    background: transparent;
    color: var(--clr-neutral-a40);
    font-weight: bold;
    border: none;
    padding: 7px 16px;
    cursor: pointer;
    font-size: 16px;
  }
}

@media (max-width: 1024px) {
  .top-bar-container {
    display: block;
  }
}

/* Мобильные устройства */
@media (max-width: 480px) { /* 375 */
    .top-bar-container {
      height: 76px;
    }

    .top-bar .sidebar-trigger {
      top: 16px;
      left: 1px;
    }

    .top-bar .logo {
      height: 76px;
    }
}
</style>